<template>
  <div ref="gridcon" style="position: relative" v-loading="!visible" :style="{height:!visible ? '500px' : ''}">
    <!--columns : {{columns}}-->
    <!--<hr>-->
    <!--fwCols :{{$store.state.permission.fwCols['55252102885140']}}-->
    <!--<hr>-->
    <!--renderColumns: {{renderColumns}}-->
    <!--renderColumns :  {{renderColumns}}-->
    <!--getCols : {{getCols}}-->
    <el-table size="small" class="egrid"
              :data="getData" ref="grid"
              v-bind="tableBind"
              v-if="visible"
              :style="{maxHeight:tableHeight}"
              :row-class-name="tableRowClassName"
              @selection-change="handleSelectionChange"
              v-on="$listeners"
    >
      <template v-for="tp in columnTypes">
        <el-table-column v-if="tp === 'expand'" type="expand" :key="tp">
          <template slot-scope="props">
            <slot name="expand" v-bind="props"></slot>
          </template>
        </el-table-column>
        <el-table-column v-else-if="tp === 'index'" align="center" :type="tp" :key="tp" width="32" :fixed="tp=='fixed'?'left':''"></el-table-column>
        <el-table-column v-else-if="tp === 'selection'" align="center" :type="tp" :key="tp" width="34"></el-table-column>
      </template>
        <el-table-column v-for="col in renderColumns"  :render-header="col.renderHeader" :key="col.label" v-bind="getColBind(col)">
        <template slot-scope="scope" >
          <component :is="col.component"
                     v-bind="getCptBind(scope, col)"
                     v-on="col.listeners" v-if="!col.component.functional">
          </component>
          <span style="margin-left: 10px" v-else>{{(col.formatter && (typeof col.formatter ==='function'))?col.formatter(scope.row[col.prop],scope.row):scope.row[col.prop]}}</span>
        </template>
      </el-table-column>
      <template v-if="slotAppend" slot="append">
        <slot name="append" align="right"></slot>
      </template>
    </el-table>
  </div>

</template>

<script>
  import ElTable from 'element-ui/lib/table'
  import ElTableColumn from 'element-ui/lib/table-column'
  import methods from './methods'
  import Text from './text'
  import {getToken, getMenuId, setMenuId} from '@/utils/auth'

  const BOOLEAN_KEYS = [
    'fit',
    'stripe',
    'border',
    'show-header',
    'highlight-current-row',
    'default-expand-all',
    'show-summary'
  ]

  const COLUMN_PROPS = {
    align: 'left',
    component: Text
  }

  const TYPES = ['selection', 'expand', 'index']

  const COLUMN_KEY_MAP = {
    label: 'label',
    prop: 'prop'
  }

  export default {
    name: 'Egrid',

    mixins: [methods],
    data() {
      return {
        tableHeight: 'none',
        selectIndex:[],
        visible:true
      }
    },

    props: {
      data: {
        type: Array,
        default() {
          return []
        }
      },
      offsetTopAdd:{
        type:Number,
        default:0
      },
      topLength:{
        type: Number,
        default:0
      },
      columns: {
        type: Array,
        default() {
          return []
        }
      },

      columnType: [String, Array],

      columnKeyMap: Object,

      columnsProps: Object,

      columnsSchema: Object,

      columnsHandler: Function,

      slotAppend: Boolean,
      autoHeight:{
        default:false
      },
      fwCols:{
        type:Boolean,
        default:false
      },
    },

    mounted() {
      let _this=this
      this.setAutoHeight()
      window.addEventListener('resize',()=>{
      _this.setAutoHeight()
     })




    },
watch:{
  renderColumns:{
    handler(new1,old){
      this.visible = false
      setTimeout(()=>{
        this.visible = true
      },1000)
    }
  }
},
    computed: {
      getCols(){
        let oldMenuId = getMenuId();
        let fwCols =this.$store.state.permission.fwCols[oldMenuId];
        return fwCols;
      },
      getData(){
        for(let index in this.data){
          this.data[index].egridIndex = Number(index);
        }
        return this.data;
      },
      // 处理 $attrs 里面 Boolean 类型的 prop 和统一 prop 命名
      tableBind() {
        const {$attrs} = this
        const bind = {}
        Object.keys($attrs).forEach(key => {
          const v = $attrs[key]
          const uniformKey = key.replace(/([A-Z])/, '-$1').toLowerCase()
          bind[key] = ~BOOLEAN_KEYS.indexOf(uniformKey) && v === '' ? true : v
        })
        //  :height="!autoHeight?(tableHeight):'false'"
        if(!this.autoHeight){
          bind.height =this.tableHeight;
        }else{
          bind.height = (this.autoHeight>1||this.autoHeight=="auto")?this.autoHeight:undefined;
        }
        return bind
      },

      renderColumns() {
        const {
          columns,
          columnKeyMap,
          columnsHandler,
          columnsProps: props,
          columnsSchema: schema
        } = this
        const map = Object.assign({}, COLUMN_KEY_MAP, columnKeyMap)
        //获取自定义列
        let newColumns= [];
        if(this.fwCols){
          let oldMenuId = getMenuId();
          console.log("getMenuId",oldMenuId);
          let fwCols =this.$store.state.permission.fwCols[oldMenuId]
          // console.log(fwCols,'fwCols')
          // console.log("fwCols",fwCols);
          if(fwCols){
            if(fwCols.length>0){
              newColumns =[];
              for(let fwCol of fwCols){
                for(let column of columns){
                  if(fwCol.label === column.prop){
                    //将宽度width 定义为 min-width(最小宽度)
                    if(column.width && !column.minWidth){
                      column.minWidth = column.width
                      this.$delete(column,'width')
                    }
                    newColumns.push(column)
                    break;
                  }
                }
              }
            }else{
              newColumns=columns
            }
          }else{
            newColumns=columns
          }
        }else{
          newColumns=columns
        }
        //自定义列替换
        // console.log('newColumns : ',newColumns)
        const renderColumns = newColumns.map(col => {
          const mix = (schema && schema[col[map.prop]]) || {}
          const it = Object.assign({}, COLUMN_PROPS, props, col, mix)
          it.label = it[map.label]
          it.prop = it[map.prop]
          // console.log(it,"it")
          return it
        })
        return (columnsHandler && columnsHandler(renderColumns)) || renderColumns
      },

      columnTypes() {
        const {columnType: type} = this
        if (!type) return []
        if (typeof type === 'string' && ~TYPES.indexOf(type)) {
          return [type]
        }
        return (
          (Array.isArray(type) && type.filter(it => ~TYPES.indexOf(it))) || []
        )
      }
    },

    methods: {
      renderHeaderMethod(col){
        return col.renderHeader?col.renderHeader:function(){retrun;}
      },
      sortChangeHandler(){
        this.selectIndex=[]
      },
      setAutoHeight(){
        if(!this.autoHeight){
          let _this=this
          setTimeout(()=>{
            try {
              let offsetTop = _this.$refs['gridcon'].offsetTop
              let offsetTopParent = _this.$refs['gridcon'].offsetParent.offsetTop
              offsetTop = (offsetTop ? offsetTop : offsetTopParent)|| 100
              if (_this.topLength == 1) {
                offsetTop = (offsetTopParent ? offsetTopParent:_this.$refs['gridcon'].offsetParent.offsetParent.offsetTop)|| 100
              } else if (_this.topLength == 2) {
                let offsetTopParentParent = _this.$refs['gridcon'].offsetParent.offsetParent.offsetTop
                offsetTop = (offsetTopParentParent ? offsetTopParentParent : _this.$refs['gridcon'].offsetParent.offsetParent.offsetParent.offsetTop)|| 100
              }
              this.tableHeight = window.innerHeight - offsetTop - 43 - _this.offsetTopAdd +'px';
            }catch (e) {

            }

          },100)


          // const forms = document.querySelectorAll('#app form.el-form.el-form--inline')[0];
          // let formsHeight = parseInt(window.getComputedStyle(forms).height);
          // console.log(formsHeight,878);
          // if(itrue){
          //
          // }
          let moreBtn= document.querySelectorAll('form.el-form.el-form--inline .filters-action span span');
          if(moreBtn[0]){
            moreBtn[0].addEventListener('click',function () {
              setTimeout(()=>{
                try {
                  let offsetTop = _this.$refs['gridcon'].offsetTop
                  let offsetTopParent = _this.$refs['gridcon'].offsetParent.offsetTop
                  offsetTop = (offsetTop ? offsetTop : offsetTopParent)|| 100
                  if (_this.topLength == 1) {
                    offsetTop = (offsetTopParent ? offsetTopParent:_this.$refs['gridcon'].offsetParent.offsetParent.offsetTop)|| 100
                  } else if (_this.topLength == 2) {
                    let offsetTopParentParent = _this.$refs['gridcon'].offsetParent.offsetParent.offsetTop
                    offsetTop = (offsetTopParentParent ? offsetTopParentParent : _this.$refs['gridcon'].offsetParent.offsetParent.offsetParent.offsetTop)|| 100
                  }
                  _this.tableHeight = window.innerHeight - offsetTop - 43 - _this.offsetTopAdd +'px';
                }catch (e) {

                }

              })

            })
          }

        }
      },
      tableRowClassName(row) {
        for(let index of this.selectIndex){
          if (row.row.id === index) {
            return 'success-row';
          }
        }
      },
      handleSelectionChange(val) {
       this.selectIndex=[];
       for(let item of val){
         this.selectIndex.push(item.id);
       }
      },
      getColBind(col) {
        const bind = Object.assign({}, col)
        delete bind.component
        delete bind.listeners
        delete bind.propsHandler
        return bind
      },

      getCptBind({row, column}, col) {
        const props = {row, col, column}
        const handler = col.propsHandler
        return (handler && handler(props)) || props
      },
      toggleRowSelection(row){
        this.$refs.grid.toggleRowSelection(row);
      },
      clearSelection(){
        this.$refs.grid.clearSelection();
      }
    },

    components: {
      [ElTable.name]: ElTable,
      [ElTableColumn.name]: ElTableColumn
    }
  }
</script>

